import React, { FC, useEffect } from 'react';
import { SetPasswordModal } from '../../account/set-password-modal/SetPasswordModal';
import { snakeToCamel } from '../../caseUtils';
import {
  SignUpPhoneModal,
  FROM_PHONE_MODAL_TO_SETTINGS_PARAM,
} from '../../signup/signup-phone-modal/SignUpPhoneModal';
import { SignUpValidationModal } from '../../signup/signup-validation/SignUpValidationModal';
import { JOIN_ORGANIZATION_VALIDATION_URL } from '../../../../shared/constants/urlConstants';
import { useUser } from '../../user/useUser';
import { useModal } from '../../components/modal/useModal';
import { SetPasswordErrorModal } from './SetPasswordErrorModal';

/* eslint-disable camelcase */
interface CustomWindow extends Window {
  password_reset_data: {
    password_reset_code: string;
    user_id: number;
    email: string;
  };
}
/* eslint-enable camelcase */

type PasswordResetData = {
  passwordResetCode: string;
  userId: number;
  email: string;
};

declare let window: CustomWindow;

export const GlobalModalesWizard: FC = () => {
  const { currentUser } = useUser();
  const { openModal: openSignupPhoneModal } = useModal((modalProps) => (
    <SignUpPhoneModal {...modalProps} user_id={currentUser.id} />
  ));
  const { openModal: openSignupValidationModal } = useModal((modalProps) => (
    <SignUpValidationModal {...modalProps} />
  ));
  const { openModal: openSetPasswordErrorModal } = useModal((modalProps) => (
    <SetPasswordErrorModal {...modalProps} />
  ));
  const { openModal: openSetPasswordModal } = useModal<PasswordResetData>(
    (modalProps) => (
      <SetPasswordModal
        passwordResetData={modalProps.customProps}
        {...modalProps}
      />
    ),
  );

  useEffect(() => {
    // open modal on load
    const passwordResetData: PasswordResetData = snakeToCamel(
      window.password_reset_data,
    );
    const shouldDisplaySignUpValidation = window.location.pathname.includes(
      JOIN_ORGANIZATION_VALIDATION_URL,
    );
    const shouldDisplayResetPasswordError = window.location.search.includes(
      'reset-invalid-code',
    );

    if (
      currentUser &&
      currentUser.askPhoneNumber &&
      !window.location.search.includes(FROM_PHONE_MODAL_TO_SETTINGS_PARAM)
    ) {
      openSignupPhoneModal();
    } else if (passwordResetData) {
      openSetPasswordModal(passwordResetData);
    } else if (shouldDisplaySignUpValidation) {
      openSignupValidationModal();
    } else if (shouldDisplayResetPasswordError) {
      openSetPasswordErrorModal();
    }
  }, []);

  return null;
};
